export function Error() {
  return (
    <div className="wrapper d-flex align-items-center justify-content-center">
      <h3>Error</h3>
    </div>
  );
}
